import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { cn } from '../../../../utils/cn';
import { REMINDER_CHANNELS } from '../utils/collectionReminders';

const CHANNEL_NOT_CONFIGURED = {
  email: 'El envío por correo no está configurado en este entorno: esos recordatorios no se enviarán.',
  whatsapp: 'El envío por WhatsApp no está configurado en este entorno: esos recordatorios no se enviarán.',
};

/**
 * Aviso de lo que el ENTORNO no permite enviar (`delivery` de GET settings): el envío
 * apagado por el kill switch de billing o un canal sin credenciales. Sin esto el operador
 * configura o programa algo que nunca sale y no se entera.
 *
 * @param {{ delivery?: { schedulerEnabled: boolean, emailConfigured: boolean,
 *   whatsappConfigured: boolean }, channels?: string[], className?: string }} props
 *   `channels`: los que interesan (p. ej. los elegidos); por defecto, ambos.
 */
export default function DeliveryStatusBanner({ delivery, channels = REMINDER_CHANNELS, className }) {
  const { t } = useTranslation();
  if (!delivery) return null;

  const messages = [];
  if (!delivery.schedulerEnabled) {
    messages.push(
      t('El envío de recordatorios está apagado en este entorno: podés dejar todo configurado, pero no saldrá ninguno (automático, programado ni manual) hasta que se habilite.'),
    );
  } else {
    if (channels.includes('email') && !delivery.emailConfigured) messages.push(t(CHANNEL_NOT_CONFIGURED.email));
    if (channels.includes('whatsapp') && !delivery.whatsappConfigured) {
      messages.push(t(CHANNEL_NOT_CONFIGURED.whatsapp));
    }
  }
  if (messages.length === 0) return null;

  return (
    <div
      className={cn(
        'flex items-start gap-2 rounded-md bg-status-warning-soft px-3 py-2 text-sm text-status-warning',
        className,
      )}
      role="status"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <div className="space-y-1">
        {messages.map((m) => (
          <p key={m} className="m-0">
            {m}
          </p>
        ))}
      </div>
    </div>
  );
}
